module.exports = __webpack_public_path__ + "static/media/CARD_BRONZE@3x.862b640f.png";